import React, { useState, useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import ReactGA from "react-ga";
import { SurveyProvider } from "../../contexts/SurveyContext";
import { CurrentQuestionProvider } from "../../contexts/CurrentQuestionContext";
import Question from "../Question/Question";
import PrivacyPolicy from "../PrivacyPolicy/PrivacyPolicy";
import GlobalStyles from "./global.styles";
ReactGA.initialize({ trackingId: "UA-171764045-1" });

function ErrorFallback({ error, componentStack, resetErrorBoundary }) {
  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre>{error.message}</pre>
      <pre>{componentStack}</pre>
      <button onClick={resetErrorBoundary}>Try again</button>
    </div>
  );
}
const App = () => {
  const [privacyShow, setPrivacyShow] = useState(false);

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        // reset the state of your app so the error doesn't happen again
      }}
    >
      <GlobalStyles />
      <SurveyProvider>
        <CurrentQuestionProvider>
          {!privacyShow ? (
            <Question setPrivacyShow={setPrivacyShow} />
          ) : (
            <PrivacyPolicy setPrivacyShow={setPrivacyShow} />
          )}
        </CurrentQuestionProvider>
      </SurveyProvider>
    </ErrorBoundary>
  );
};

export default App;
